import(/* webpackMode: "eager" */ "/Users/macmini/Github/Solariis-Intelligence/frontend/dashboard/app/global-error.tsx");
